module.exports = __webpack_public_path__ + "img/BAADA8_ECE6E7_9A8378_E3DCD3-256px.c4a0e48c.png";